__turbopack_context__.v({
  "alertYellow": "aBnAha_alertYellow",
  "black": "aBnAha_black",
  "black90": "aBnAha_black90",
  "bodyCopy": "aBnAha_bodyCopy",
  "copy": "aBnAha_copy",
  "cyan": "aBnAha_cyan",
  "darkStone": "aBnAha_darkStone",
  "embeddedVideoSection": "aBnAha_embeddedVideoSection",
  "fuschiaPunch": "aBnAha_fuschiaPunch",
  "item": "aBnAha_item",
  "limeSorbet": "aBnAha_limeSorbet",
  "olive100": "aBnAha_olive100",
  "olive20": "aBnAha_olive20",
  "paddingBottom0": "aBnAha_paddingBottom0",
  "paddingBottom112": "aBnAha_paddingBottom112",
  "paddingBottom128": "aBnAha_paddingBottom128",
  "paddingBottom16": "aBnAha_paddingBottom16",
  "paddingBottom32": "aBnAha_paddingBottom32",
  "paddingBottom48": "aBnAha_paddingBottom48",
  "paddingBottom64": "aBnAha_paddingBottom64",
  "paddingBottom80": "aBnAha_paddingBottom80",
  "paddingBottom96": "aBnAha_paddingBottom96",
  "paddingTop0": "aBnAha_paddingTop0",
  "paddingTop112": "aBnAha_paddingTop112",
  "paddingTop128": "aBnAha_paddingTop128",
  "paddingTop16": "aBnAha_paddingTop16",
  "paddingTop32": "aBnAha_paddingTop32",
  "paddingTop48": "aBnAha_paddingTop48",
  "paddingTop64": "aBnAha_paddingTop64",
  "paddingTop80": "aBnAha_paddingTop80",
  "paddingTop96": "aBnAha_paddingTop96",
  "played": "aBnAha_played",
  "softBlack": "aBnAha_softBlack",
  "teal100": "aBnAha_teal100",
  "teal20": "aBnAha_teal20",
  "title": "aBnAha_title",
  "video": "aBnAha_video",
  "videoContent": "aBnAha_videoContent",
  "warmStone": "aBnAha_warmStone",
  "white": "aBnAha_white",
});
